var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  "+_vm._s(_vm.data.priceSell)+" "+_vm._s(_vm.data.currencySell && _vm.data.currencySell.code)+" "),(_vm.data.incotermSell)?[_vm._v("("+_vm._s(_vm.data.incotermSell.name)+")")]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }